import { render, staticRenderFns } from "./ActivateOCRHistory.vue?vue&type=template&id=ecc5fd90&scoped=true"
import script from "./ActivateOCRHistory.vue?vue&type=script&lang=js"
export * from "./ActivateOCRHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc5fd90",
  null
  
)

export default component.exports